import { useEffect } from "react";
import CookieBanner from "@/components/layout/cookie-banner";
import PwaInstallBanner from "@/components/layout/pwa-install-banner";
import ScrollToTop from "@/components/layout/scroll-to-top";
import SiteFooter from "@/components/layout/site-footer";
import SiteHeader from "@/components/layout/site-header";
import SiteBreadcrumb from "@/components/layout/site-breadcrumb";
import SiteSearchBand from "@/components/layout/site-search-band";
import BackToTop from "@/components/layout/back-to-top";
import ServiceCommerceDock from "@/components/layout/service-commerce-dock";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

export default function SiteLayout() {
  const { t, i18n } = useTranslation("common");
  useEffect(() => {
    const script = document.createElement("script");
    script.src="/support-launcher.js?v=20261011f"; script.dataset.host="main"; script.dataset.language=i18n.language.slice(0,2);
    document.body.append(script);
    return()=>{ script.remove(); document.getElementById("enkey-support-root")?.remove(); };
  },[i18n.language]);

  return (
    <div
      data-public-site
      className="flex min-h-svh flex-col bg-background"
    >
      <ScrollToTop />
      {/* Skip link: visually hidden until focused via keyboard, lets keyboard
          and screen-reader users jump straight to the main content. */}
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-lg focus:bg-primary focus:px-4 focus:py-2 focus:text-sm focus:font-medium focus:text-primary-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
      >
        {t("a11y.skip_to_content")}
      </a>
      <SiteHeader />
      <SiteBreadcrumb />
      <SiteSearchBand />
      <main id="main-content" className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />
      <CookieBanner />
      <PwaInstallBanner />
      <BackToTop />
      <ServiceCommerceDock />
    </div>
  );
}
